module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "flex w-100 bg-white br3 new-shadow-theme h-100 responsive-box"
  }, [_c('div', {
    staticClass: "flex flex-column w-100"
  }, [_c('div', {
    staticClass: "w-100"
  }, [(this.showBack) ? _c('div', {
    staticClass: "flex",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    staticClass: "mr1 icon-back",
    attrs: {
      "alt": "",
      "src": "/static/appicons/ArrowLeft.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-theme pointer mb3"
  }, [_vm._v("Back")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-box"
  }, [_c('div', {
    staticClass: "cera-round-pro-medium f4 mb3 fw5"
  }, [_vm._v("Checkout Summary")]), _vm._v(" "), (_vm.filteredPhones.length > 1) ? _c('div', {
    staticClass: "mb4"
  }, [_c('label', {
    staticClass: "f6 fw5 di mb2 lh-copy inter"
  }, [_vm._v("\n            Please enter the cell phone number that will be associated with each plan below.\n            Each person will receive a text message with their own login credentials after you checkout.\n            Each person must login from their own phone and complete verification on their own device.\n          ")])]) : _c('div', {
    staticClass: "mb4"
  }, [_c('label', {
    staticClass: "f6 fw5 di mb2 lh-copy inter"
  }, [_vm._v("\n            Please enter the cell phone number that will be associated with the plan below.\n            You will receive a text message with login credentials after checkout.\n          ")])]), _vm._v(" "), _vm._l((_vm.coverages), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "flex flex-column"
    }, [(index !== 0) ? _c('div', {
      staticClass: "w-100 separation-line mv3"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "flex flex-row phone-form justify-between"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "inter f6-ns black-40 mr2 responsive-none"
    }, [_vm._v("\n                #" + _vm._s(index + 1) + "\n              ")]), _vm._v(" "), _c('phone-form', {
      attrs: {
        "deviceModel": item.make + ' ' + item.model,
        "devices": _vm.secondStepDevices,
        "index": index,
        "planInfo": item.display_name === null ? item.name : item.display_name,
        "setPhoneNumber": _vm.setPhoneNumber
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex flex-row primary items-center center-dot"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.primary),
        expression: "primary"
      }],
      staticClass: "pointer",
      attrs: {
        "id": index,
        "disabled": _vm.disablePrimaryCellphone,
        "name": "primary",
        "type": "radio"
      },
      domProps: {
        "value": index,
        "checked": _vm._q(_vm.primary, index)
      },
      on: {
        "change": [function($event) {
          _vm.primary = index
        }, _vm.onPrimaryChange]
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "inter f6 silver tl buttonUnselected left ml2 pointer",
      attrs: {
        "for": index
      }
    }, [_vm._v("\n                  Primary Account\n                ")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "inter flex f6 center-dot responsive-none"
    }, [_vm._v("$" + _vm._s(_vm.filteredPhones[index].price.toFixed(2)) + " /\n              " + _vm._s(_vm.monthlyToggle ? 'month' : 'year') + "\n            ")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "container-box mt4"
  }, [_c('div', {
    staticClass: "cera-round-pro-medium f4 mb3 fw5"
  }, [_vm._v("Payment Information")]), _vm._v(" "), _c('plan-type-toggle', {
    attrs: {
      "setValue": _vm.setIsCreditCard,
      "toggleValue": !_vm.isCreditCard,
      "customClass": "tc mt2 w-100 items-center justify-between h-20 mb2 responsive-toggle",
      "customTextClass": "f7",
      "firstOption": "Bank Account",
      "secondOption": "Credit/Debit Card",
      "toggleName": "pay-method"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCreditCard),
      expression: "isCreditCard"
    }],
    staticClass: "mt4"
  }, [(_vm.isOpenMessage) ? _c('div', {
    staticClass: "flex flex-row pv2 ph3 justify-between align-center bank-box relative"
  }, [_c('triangle-icon', {
    staticClass: "triangle",
    attrs: {
      "height": "21px",
      "width": "21px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row align-center"
  }, [_c('alert-icon', {
    staticClass: "icons"
  }), _vm._v(" "), _c('div', {
    staticClass: "inte color-gray f6 ml3 justify-center self-center bank-message"
  }, [_vm._v("\n                Change to bank account and get $20 in deductible credit for future claims!\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "icons",
    on: {
      "click": _vm.closeMessage
    }
  }, [_c('close-icon')], 1)], 1) : _vm._e(), _vm._v(" "), _c('personal-form', {
    attrs: {
      "emailError": _vm.emailError,
      "firstValue": _vm.internalFirstName,
      "isOpenMessage": _vm.isOpenMessage,
      "secondValue": _vm.internalLastName,
      "thirdValue": _vm.internalEmail,
      "fourthValue": _vm.internalPostalCode,
      "firstLabel": "First Name",
      "secondLabel": "Last Name",
      "thirdLabel": "Email Address",
      "fourthLabel": "Postal Code"
    },
    on: {
      "update:firstValue": function($event) {
        _vm.internalFirstName = $event
      },
      "update:first-value": function($event) {
        _vm.internalFirstName = $event
      },
      "update:secondValue": function($event) {
        _vm.internalLastName = $event
      },
      "update:second-value": function($event) {
        _vm.internalLastName = $event
      },
      "update:thirdValue": function($event) {
        _vm.internalEmail = $event
      },
      "update:third-value": function($event) {
        _vm.internalEmail = $event
      },
      "update:fourthValue": function($event) {
        _vm.internalPostalCode = $event
      },
      "update:fourth-value": function($event) {
        _vm.internalPostalCode = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "inter f6 color-theme"
  }, [_vm._v(_vm._s(_vm.cardErrorMessage))])])], 1), _vm._v(" "), _c('bank-account', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCreditCard),
      expression: "!isCreditCard"
    }],
    attrs: {
      "email": _vm.internalEmail,
      "emailError": _vm.emailError,
      "isDataFilled": _vm.isBankDataFilled
    },
    on: {
      "update:email": function($event) {
        _vm.internalEmail = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container-box mt4"
  }, [(this.showCouponInput) ? _c('label', {
    staticClass: "cera-round-pro fw6 db title"
  }, [_vm._v("Promotions")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "inter black-40 enter-code"
  }, [_vm._v("Enter a promotion code you have, or select from one of our current promotions below! Limit 1 per transaction/promotions are not stackable.")]), _vm._v(" "), _c('discount-code3c', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.showCouponInput),
      expression: "this.showCouponInput"
    }],
    staticClass: "mt3",
    attrs: {
      "discount": _vm.discount,
      "isBiggerCoupon": _vm.isBiggerCoupon,
      "isMonthly": _vm.monthlyToggle,
      "oneTimeVerification": _vm.oneTimeVerification,
      "price": _vm.price,
      "totalPrice": _vm.totalPrice,
      "totalPriceWithoutDiscount": _vm.totalPriceWithoutDiscount
    },
    on: {
      "update:discount": function($event) {
        _vm.discount = $event
      },
      "update:oneTimeVerification": function($event) {
        _vm.oneTimeVerification = $event
      },
      "update:one-time-verification": function($event) {
        _vm.oneTimeVerification = $event
      },
      "update:price": function($event) {
        _vm.price = $event
      },
      "update:totalPrice": function($event) {
        _vm.totalPrice = $event
      },
      "update:total-price": function($event) {
        _vm.totalPrice = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column"
  }, [(this.showPromotionBox) ? _c('div', {
    staticClass: "flex pb3 mb1 responsive-carousel"
  }, [_c('carousel-discount', {
    attrs: {
      "applied": _vm.twoYearsUpfrontSelected,
      "discount": _vm.twoYearsUpfrontDiscountPercent + '%',
      "isBiggerCoupon": _vm.isBiggerCoupon,
      "setAnnual": _vm.setSecondValue,
      "setisBiggerCoupon": _vm.setisBiggerCoupon,
      "subtitle": _vm.monthlyToggle ? ("By switching to annual save an extra $" + (_vm.savings.toFixed(2)) + "/yr.") : '',
      "title": _vm.twoYearsUpfrontDiscountTitle,
      "isTwoYear": "",
      "subDiscount": "off"
    }
  }), _vm._v(" "), (_vm.enteredDiscount.code_name) ? _c('carousel-discount', {
    attrs: {
      "applied": true,
      "discount": ("$" + ((this.calculateDiscountAmount(_vm.enteredDiscount,0)).toFixed(2))),
      "title": _vm.enteredDiscount.code_name,
      "isCoupon": true,
      "code": _vm.enteredDiscount.code,
      "subDiscount": "off",
      "subtitle": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isMultiPlanDiscount) ? _c('carousel-discount', {
    attrs: {
      "applied": true,
      "discount": "5%",
      "subDiscount": "off",
      "subtitle": "Already applied in your order total",
      "title": "Multi-Plan Discount"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-100 separation-line mv3 responsive-appear"
  }), _vm._v(" "), _c('checkout-summary', {
    attrs: {
      "billable-per-year": _vm.billablePerYear,
      "discount": _vm.discount,
      "enteredDiscount": _vm.enteredDiscount,
      "filteredPhones": _vm.filteredPhones,
      "has-non-coupon-discount": _vm.hasNonCouponDiscount,
      "isBiggerCoupon": _vm.isBiggerCoupon,
      "monthly-toggle": _vm.monthlyToggle,
      "disableIntervalToggle": _vm.disableIntervalToggle,
      "non-coupon-discount": _vm.nonCouponDiscount,
      "price": _vm.price,
      "savings": _vm.savings,
      "set-first-value": _vm.setFirstValue,
      "set-second-value": _vm.setSecondValue,
      "total": _vm.total,
      "total-price": _vm.totalPrice,
      "two-years-upfront-selected": _vm.twoYearsUpfrontSelected,
      "twoYearsUpfrontDiscountAmount": _vm.twoYearsUpfrontDiscountAmount
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "separation-line w-100 mt4"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column flex-column-m items-center mt4-ns mt3"
  }, [_c('terms-and-conds', {
    attrs: {
      "isChecked": _vm.hasAgreed,
      "isStudent": _vm.isStudent,
      "onCheck": _vm.onCheck,
      "customClass": "ph0"
    }
  }), _vm._v(" "), _c('ak-button', {
    attrs: {
      "newDisabled": _vm.disabledButton,
      "block": "",
      "customClass": "btn-reg",
      "newPrimary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            Register Now\n          ")])], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-row justify-between mb3 responsive-pay"
  }, [_c('div', {
    staticClass: "w-50 max-card responsive-card"
  }, [_c('div', {
    staticClass: "mr3 max-code",
    attrs: {
      "id": "card-number"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row w-50 max-code"
  }, [_c('div', {
    staticClass: "small-input w-50 mr3",
    attrs: {
      "id": "card-expiry"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small-input w-50",
    attrs: {
      "id": "card-cvc"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-785d8739", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-785d8739","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/formBox/UnifiedCheckout.vue
// module id = 1075
// module chunks = 0